import { useQuery } from '@tanstack/react-query';
import { getBuiltInMcpServers, USER_MCP_QUERY_KEYS } from '../../api';

/**
 * The built-in (platform) MCP servers — always available, not user-managed. Returns ONLY platform
 * servers; the org catalog has its own hook (`useInstallableCatalog`), so there's no overlap. The
 * UI lists these read-only with a "Built-in" label and no install/manage actions.
 */
export const useBuiltInMcpServers = (enabled = true) =>
  useQuery({
    queryKey: USER_MCP_QUERY_KEYS.builtIn,
    queryFn: getBuiltInMcpServers,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
